module.exports = __webpack_public_path__ + "img/cibc-logo-lg.7805251a.png";